export default "__VITE_ASSET__s0e3AaZQ__";